module.exports = __webpack_public_path__ + "static/NTG-5b564db4816476ca3fd65ed9e958109e.png";